function error(source, message) {
  throw Error(`Varlet [${source}]: ${message}`);
}
function warn(source, message) {
  console.warn(`Varlet [${source}]: ${message}`);
}
export {
  error,
  warn
};
